/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState, useEffect } from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { useGetBrand } from 'src/feature-app/hooks';


const etiquetaC = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_c.png';
const etiquetaEco = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_eco.png';
const etiquetaZero = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_0.png';

interface EtiquetaDGTProps {
  brand: string;
}

const EtiquetaDgt = styled.img<EtiquetaDGTProps>`
  width: 8%;
  height: auto;
  position: absolute;
  top: ${(props)=>props.brand === 'V' ? '32px' : '0'};
  left: ${(props)=>props.brand === 'V' ? '44px' : null};
  right: ${(props)=>props.brand === 'V' ? null : '0'};
`;

interface EtiquetaProps {
  combustible: string;
}

export const EtiquetaDGT = (props: EtiquetaProps) => {

  const { combustible } = props;
  const [ imgSrc, setImgSrc ] = useState(null);
  const brand = useGetBrand();

  useEffect(()=>{
    if(combustible === '0') {
      setImgSrc(etiquetaZero);
    } else if (combustible === 'C') {
      setImgSrc(etiquetaC);
    } else if (combustible === 'ECO') {
      setImgSrc(etiquetaEco);
    } else {
      setImgSrc('');
    }
  }, [combustible]);

  return imgSrc ? <EtiquetaDgt src={imgSrc} alt='etiqueta dgt' brand={brand}/> : null;
 
};
